import type { KgInsight } from '@api/api/kg-insights';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { KgInsightPreview } from '@terminal/widgets/catalyst-insights-drawer/catalyst-widget/components/kg-insight-content/KgInsightPreview';
import { resolveKgInsightChartHeaderConfig } from '@terminal/widgets/catalyst-insights-drawer/catalyst-widget/utils/catalyst-widget-utils';
import type { RefCallback } from 'react';

import { isKgInsightSectionVisible } from '../../utils/kg-insight-utils';
import { KgInsightSection } from '../kg-insight-section/KgInsightSection';
import { KgInsightSectionRenderer } from '../kg-insight-section-renderer/KgInsightSectionRenderer';

type KgInsightArticleProps = {
  kgInsight: KgInsight;
  setSectionRef: (id: string) => RefCallback<HTMLElement>;
};

export const KgInsightArticle = ({
  kgInsight,
  setSectionRef,
}: KgInsightArticleProps) => {
  const isInsightDrawerHeaderEnabled = useFlags(state =>
    state.getFeatureFlagState('PLATFORM-4942-insight-drawer-header')
  );

  const chartHeaderConfig = resolveKgInsightChartHeaderConfig({
    isRedesignEnabled: isInsightDrawerHeaderEnabled,
    kgInsight,
    trackingSource: POSTHOG_TRACKING_SOURCES.KG_INSIGHT_PAGE,
  });

  return (
    <>
      <KgInsightSection ref={setSectionRef('hero')}>
        <KgInsightPreview {...chartHeaderConfig} kgInsight={kgInsight} />
      </KgInsightSection>

      {kgInsight.sections.filter(isKgInsightSectionVisible).map(section => (
        <KgInsightSectionRenderer
          key={section.type}
          section={section}
          kgInsight={kgInsight}
          setSectionRef={setSectionRef}
        />
      ))}
    </>
  );
};
